import * as React from "react";
import { Container, Col, Row } from 'react-bootstrap';
import { useStaticQuery, graphql } from 'gatsby';
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const BlogList = ({
  title = "Featured <span class='text-primary'>blogs</span>",
  description = "Stay ahead of the curve by reading our latest blogs based on real experience and the latest technology.",
  sectionClass = 'bg-light',
  category
}) => {

  const { allMdx } = useStaticQuery(graphql`
    query BlogList {
      allMdx(sort: { frontmatter: { modifyDate: DESC } }) {
        edges {
          node {
            fields {
              slug
            }
            frontmatter {
              date(formatString: "MMMM DD, YYYY")
              modifyDate(formatString: "MMMM DD, YYYY")
              title
              categories
              featured {
                childImageSharp {
                  gatsbyImageData(width: 416, height: 245)
                }
              }  
            }
          }
        }
      }
    }
  `);

  const posts = allMdx.edges;

  return (
    <>
      <section className={`section blog-list-section ${sectionClass}`}>
        <Container className="py-5">
          <div className="mb-4 pb-1">
            <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: title }} />
            <p className="max-width-950 lead">{description}</p>
          </div>
          <Row xs={1} md={2} lg={3} className="g-4">
            {category ? posts
              .filter(edge => edge.node.frontmatter.categories?.some(i => category.includes(i)))
              //.filter(edge => edge.frontmatter.categories.includes(category))
              .map((post, index) => index < 3 && (
                <Col key={index}>
                  <Link to={post.node.fields.slug} className="blog-list-card single">
                    <div className="blog-image">
                      <GatsbyImage loading="lazy" width={416} height={245} image={getImage(post.node.frontmatter.featured)} alt="featured" />
                    </div>
                    <div className="blog-list-content mt-4">
                      <p className="single-line-meta text-muted mb-3 font-size-14"><span>{post.node.frontmatter.date}</span></p>
                      <h2 className="blog-title h5 fw-normal">{post.node.frontmatter.title}</h2>
                    </div>
                  </Link>
                </Col>
              )) :
              posts.map((post, index) => index < 3 && (
                <Col key={index}>
                  <Link to={post.node.fields.slug} className="blog-list-card single">
                    <div className="blog-image">
                      <GatsbyImage loading="lazy" width={416} height={245} image={getImage(post.node.frontmatter.featured)} alt="featured" />
                    </div>
                    <div className="blog-list-content mt-4">
                      <p className="single-line-meta text-muted mb-2 font-size-14"><span>{post.node.frontmatter.modifyDate}</span></p>
                      <h2 className="blog-title h5 fw-normal">{post.node.frontmatter.title}</h2>
                    </div>
                  </Link>
                </Col>
              ))
            }
          </Row>
          <div className="text-center mt-4 pt-4">
            <Link to="/blog.html" className="btn btn-link">
              <span>View more blogs</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
            </Link>
          </div>
        </Container>
      </section>
    </>
  )
}

export default BlogList;
